/**
 * PageNumberFieldExtension — Inline atom node for {page} placeholder.
 *
 * Used in the header/footer mini editor to represent auto-incrementing page numbers.
 * Renders as a non-editable chip showing "{page}" and serializes to the {page} text
 * that PaginationPlus recognizes.
 */

import { Node, mergeAttributes } from "@tiptap/core";

export interface PageNumberFieldOptions {
  HTMLAttributes: Record<string, any>;
}

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    pageNumberField: {
      insertPageNumber: () => ReturnType;
    };
  }
}

export const PageNumberFieldExtension = Node.create<PageNumberFieldOptions>({
  name: "pageNumberField",

  group: "inline",
  inline: true,
  atom: true,
  selectable: true,
  draggable: false,

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  parseHTML() {
    return [
      {
        tag: 'span[data-type="page-number-field"]',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "span",
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
        "data-type": "page-number-field",
        class: "page-number-field",
        contenteditable: "false",
        style:
          "display: inline-block; padding: 1px 6px; background: #e8eaed; border-radius: 3px; font-size: 11px; color: #5f6368; font-family: monospace; user-select: all; cursor: default;",
      }),
      "{page}",
    ];
  },

  addCommands() {
    return {
      insertPageNumber:
        () =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
          });
        },
    };
  },
});

export default PageNumberFieldExtension;
